import './shared-game-footer.css';

export default function SharedGameFooter({ gameKey, gameName }: { gameKey: string; gameName: string }) {
  return (
    <footer className="shared-game-footer">
      <div>
        <strong>GAME WIKI</strong>
        <p>{gameName}玩家资料站<span className="shared-game-footer-period">。</span></p>
      </div>
      <nav aria-label="页脚导航">
        <a href={`/${gameKey}`}>关于 Wiki</a>
        <a href={`/${gameKey}/dcommunity`}>贡献指南</a>
        <a href={`/${gameKey}/dcommunity`}>反馈</a>
      </nav>
    </footer>
  );
}
